/* Cross sell cards: the rail in the cart drawer and the matching panel on the
   PDP. Each card carries its own variant map,
   so the colour swatches, the size select and the add button stay in step
   without another network call. Rebound after every drawer re-render. */
(function () {
  const bindCard = (card) => {
    if (card.dataset.bound) return;
    card.dataset.bound = '1';

    let data;
    try {
      data = JSON.parse(card.querySelector('[data-xsell-json]').textContent);
    } catch (e) {
      return;
    }

    const select = card.querySelector('[data-xsell-size]');
    const addBtn = card.querySelector('[data-xsell-add]');
    const img = card.querySelector('.cart-xsell__img');
    const swatches = [...card.querySelectorAll('[data-xsell-colour]')];
    let colour = swatches.length ? swatches[0].dataset.xsellColour : '';

    const sizesFor = (c) => data.variants.filter((v) => (!c || v.c === c));

    const fillSizes = () => {
      if (!select) return;
      const options = sizesFor(colour);
      select.innerHTML = options
        .map((v) => `<option value="${v.id}" ${v.a ? '' : 'disabled'}>${v.s || 'One size'}${v.a ? '' : ' (sold out)'}</option>`)
        .join('');
      const firstAvailable = options.find((v) => v.a);
      if (firstAvailable) select.value = firstAvailable.id;
      addBtn.disabled = !firstAvailable;
    };

    const paintSwatch = (c) => {
      const src = (data.images || {})[c];
      if (src && img) img.src = src;
    };

    swatches.forEach((sw) => {
      sw.addEventListener('click', () => {
        colour = sw.dataset.xsellColour;
        swatches.forEach((s) => s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'));
        paintSwatch(colour);
        fillSizes();
      });
    });

    addBtn.addEventListener('click', async () => {
      const id = select ? Number(select.value) : (data.variants.find((v) => v.a) || {}).id;
      if (!id) return;
      addBtn.disabled = true;
      const label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add failed');
        /* Re-render the drawer so the new line, the totals and this rail all
           refresh together, which also drops the product just added. */
        const drawer = document.querySelector('cart-drawer');
        const sections = await (await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)).json();
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents({ sections });
        else window.location.reload();
      } catch (e) {
        addBtn.textContent = label;
        addBtn.disabled = false;
      }
    });

    paintSwatch(colour);
    fillSizes();
  };

  const bindRail = () => {
    /* The PDP matching panel emits the same data-xsell-* payload, so it gets
       the same size select and add to cart behaviour without a second script. */
    document.querySelectorAll('.pdp-match__card').forEach(bindCard);

    document.querySelectorAll('.cart-xsell').forEach((rail) => {
      rail.querySelectorAll('.cart-xsell__item').forEach(bindCard);
      const track = rail.querySelector('[data-xsell-track]');
      const step = () => (track.querySelector('.cart-xsell__item')?.getBoundingClientRect().width || 260) + 16;
      rail.querySelector('[data-xsell-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      rail.querySelector('[data-xsell-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  };

  document.addEventListener('DOMContentLoaded', bindRail);
  new MutationObserver(bindRail).observe(document.body, { childList: true, subtree: true });
  bindRail();
})();
